import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';

import LabelReportsIndex from './LabelReportsIndex.vue';
import LabelReportsShow from './LabelReportsShow.vue';
import LabelReports from './LabelReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import Atendimento from './Atendimento.vue';

// ACESSO-01 (L8b): com a chave ACESSO_GRANULAR ligada, os relatórios pedem o `reports:read` (`ReportPolicy#view?`,
// `atendimento#*`), em toda rota daqui. O CSAT e os robôs seguem da plataforma (`superAdminOnly`).
const ESCOPOS = ['reports:read'];

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'client', 'report_manage'],
  escopos: ESCOPOS,
};

// A página Atendimento (REPORTS-02) pede o que as rotas de relatório v2 pedem no
// servidor (`ReportPolicy#view?`): administrador, ou um papel com `report_manage`.
const atendimentoMeta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
  escopos: ESCOPOS,
};

// REPORTS-02: as abas de Visão geral, Conversas, Atendentes, Caixa de Entrada e
// Time viraram a página Atendimento. Cada rota antiga fica de pé, com o nome e a
// permissão de antes, e abre a página já filtrada — link salvo e favorito não
// caem em 404 (o padrão das campanhas). O período vem junto; o horário comercial
// e o agrupamento, que a página não tem, ficam para trás. REPORTS-03: os de
// atendentes, caixas e times abrem a aba Canais e times.
const toAtendimento =
  (filters = () => ({})) =>
  route => {
    const { range, from, to } = route.query;
    return {
      name: 'account_atendimento_reports',
      params: { accountId: route.params.accountId },
      query: Object.fromEntries(
        Object.entries({ range, from, to, ...filters(route) }).filter(
          ([, value]) => value !== undefined
        )
      ),
    };
  };

const revisedMeta = {
  permissions: ['administrator', 'client', 'report_manage'],
  escopos: ESCOPOS,
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    redirect: toAtendimento(() => ({ tab: 'canais', comparar: 'user' })),
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    redirect: toAtendimento(() => ({ tab: 'canais', comparar: 'inbox' })),
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    redirect: toAtendimento(() => ({ tab: 'canais', comparar: 'team' })),
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: revisedMeta,
    redirect: toAtendimento(() => ({ tab: 'canais', comparar: 'user' })),
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: revisedMeta,
    redirect: toAtendimento(route => ({
      tab: 'canais',
      agent_id: route.params.id,
    })),
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: revisedMeta,
    redirect: toAtendimento(() => ({ tab: 'canais', comparar: 'inbox' })),
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: revisedMeta,
    redirect: toAtendimento(route => ({
      tab: 'canais',
      inbox_id: route.params.id,
    })),
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: revisedMeta,
    redirect: toAtendimento(() => ({ tab: 'canais', comparar: 'team' })),
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: revisedMeta,
    redirect: toAtendimento(route => ({
      tab: 'canais',
      team_id: route.params.id,
    })),
  },
  // Etiquetas continuam de pé: a página Atendimento não filtra por etiqueta, e
  // levar para lá perderia o filtro calado.
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: revisedMeta,
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: revisedMeta,
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_atendimento_reports', params: to.params };
          },
        },
        {
          path: 'atendimento',
          name: 'account_atendimento_reports',
          meta: atendimentoMeta,
          component: Atendimento,
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          redirect: toAtendimento(),
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          redirect: toAtendimento(),
        },
        // REPORTS-03: Carrinhos virou aba de Relatórios; a conta sem a flag
        // cai em Agora.
        {
          path: 'carrinhos',
          name: 'account_cart_reports',
          meta,
          redirect: toAtendimento(() => ({ tab: 'carrinhos' })),
        },
        // REPORTS-03: a Analytics dos agentes (REPORTS-01) virou a aba A IA, e a
        // segunda cópia saiu.
        {
          path: 'analytics',
          name: 'account_analytics_reports',
          meta,
          redirect: toAtendimento(() => ({ tab: 'ia' })),
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'csat',
          name: 'csat_reports',
          meta: { ...meta, superAdminOnly: true },
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta: { ...meta, superAdminOnly: true },
          component: BotReports,
        },
      ],
    },
  ],
};
